<template>
  <iframe v-if="src" :src="src" frameborder="0" width="100%" height="100%"></iframe>
  <div v-else class="no-src">评估详情页</div>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      default: ''
    },
    classId: {
      type: String,
      default: ''
    },
    pkglId: {
      type: String,
      default: ''
    },
  },
  data () {
    return {
      src: ''
    };
  },

  components: {},

  computed: {},

  mounted() {},

  created() {
    if (!this.isDesign && this.url && this.classId && this.pkglId) {
      this.getData()
    }
  },

  methods: {
    getData() {
      const loading = dsf.layer.loading();
      this.$http
        .get(this.url, {
          classId: this.classId,
          pkglId: this.pkglId
        })
        .done((res) => {
          if (res.success && res.state == 20000 && res.data) {
            this.src = res.data.url
          } else {
            dsf.layer.message(res.message, false);
          }
        })
        .error((err) => {
          dsf.layer.message(err.message || "出错了，请重试", false);
        })
        .always(() => {
          dsf.layer.closeLoading(loading);
        });
    },
  }
}

</script>
<style scoped>
</style>